import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Button } from 'transfix-ui/core'
import { ICarrierState } from 'types'
import { getNewCarrierStatus } from 'utils/carriers/getNewCarrierStatus'
import { CARRIER_STATE_LABELS } from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard/types'
import { IStore } from 'apps/carrier/utils/reducers'
import { TAG_SIZE, Tag } from 'transfix-ui'
import { useUserDetails } from 'utils/hooks'
import { CarrierAddFlagModal } from './CarrierAddFlagModal'
import { useCarrierStateQuery } from './graphql/CarrierState'
import { useMotorCarrierComplianceFlagsQuery } from './graphql/MotorCarrierComplianceFlags'
import { getStateTagStyle } from './utils'

export const CarrierStateTag = () => {
  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierApplicationId = '' } = carrierDetails || {}
  const { data: stateData, loading } =
    useCarrierStateQuery({ variables: { carrierApplicationId } }) || {}
  const { carrierApplication } = stateData || {}
  const { state } = carrierApplication || {}

  const { data: motorCarrierComplianceFlagsData } = useMotorCarrierComplianceFlagsQuery({
    variables: {
      carrierApplicationId,
    },
  })

  const { motorCarrierComplianceFlags } = motorCarrierComplianceFlagsData || {}

  const color = getStateTagStyle(state || null, motorCarrierComplianceFlags)

  const { userPermissions } = useUserDetails()
  const { canEditComplianceCarrierInfo } = userPermissions || {}

  const prefix = motorCarrierComplianceFlags?.length ? 'Update' : 'Add'

  const fallback = loading ? 'Loading' : 'No Data'

  const label = state ? getNewCarrierStatus(CARRIER_STATE_LABELS[state]) : fallback

  const [open, setOpen] = useState<boolean>(false)

  const openHandler = () => setOpen(true)

  const closeHandler = () => setOpen(false)

  return (
    <Box display='flex' alignItems='center' flexWrap='wrap' gap='4px'>
      <Tag label={label} size={TAG_SIZE.small} tagStyle={color} />
      {canEditComplianceCarrierInfo && (
        <Button variant='text' onClick={openHandler}>
          {prefix} Flag
        </Button>
      )}
      <CarrierAddFlagModal open={open} onClose={closeHandler} />
    </Box>
  )
}
